<template>
	<div style="height: 100%;width: 100%;">
		<div v-if="selectdItem.compontChildren[0].data.imgUrl.list[0].url == '' && type == 'design'">
			请添加轮播图片
		</div>

		<el-carousel v-if="selectdItem.compontChildren[0].data.imgUrl.list[0].url != ''"
			:height="equipment == 'pc'?'50dvw':selectdItem.preStyle.compontentStyle.height + 'px'"
			style="width: 100%;">
			<el-carousel-item style="width: 100%;height: 100% ;"
				v-for="(item,index) in fifterImg(selectdItem.compontChildren[0].data.imgUrl.list) " :key="index">
				<img @click="navTo(item.link)" style="height: 100%;width: 100%;" :style="{}"   :src="item.url" />
			</el-carousel-item>
		</el-carousel>
	</div>
</template>
<script>
	export default {
		props: {
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		data() {
			return {}
		},
		mounted() {
			console.log('mounted', this.selectdItem)
		},
		methods: {
			
			getObjectFit(e) {
				if (e.preStyle.compontentStyle.percentWidthSwitch) {
					return 'cover'
				} else {
					return 'contain'
				}
			},
			getImgStyle(e) {
				console.log('getChildConentStyle e', e)
				// 文字渐变
				let style = {}
				if (this.equipment == 'pc') {
					if (e.preStyle.compontentStyle.percentWidthSwitch) {
						// style.width = '100%'
						style.width = e.preStyle.compontentStyle.width + 'px'
					} else {
						style.width = e.preStyle.compontentStyle.width + 'px'
					}
					style.height = e.preStyle.compontentStyle.height + 'px'
				}
				if (this.equipment == 'phone') {
					if (e.preStyle.compontentStylePhone.percentWidthSwitch) {
						// style.width = '100%'
						style.width = e.preStyle.compontentStylePhone.width + 'px'
					} else {
						style.width = e.preStyle.compontentStylePhone.width + 'px'
					}
					style.height = e.preStyle.compontentStylePhone.height + 'px'
				}
				console.log('getChildConentStyleegetImgStyle', style)
				return style
			},
			
			
			navTo(item) {
				console.log('hrefNavTo', item)



				let url = item.link.url
				if (item.link.jump) {
					url = item.link.jump
				}
				if (item.link.type == '站内链接') {
					let arr = item.link.name.split('#')
					url = arr[1]
				}
				if (item.link.type == "外部链接") {
					window.open(item.link.name);
					return
				}


				if (!url) {
					return
				}
				console.log('url', url)
				console.log('this.$route.path', this.$route.path)
				if (this.$route.path == '/') {
					this.$router.push({
						path: '/' + url,
					})
					this.show = false
					window.location.reload()
				} else {
					this.show = false
					this.$router.replace({
						path: '/' + url,
						query: {
							nav: new Date().getTime()
						}
					})
				}
			},
			fifterImg(list) {
				let arr = []
				list.forEach(e => {
					if (e.url != '') {
						arr.push(e)
					}
				})
				return arr
			}
		}

	}
</script>
<style>
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
</style>